import { useEffect, useState } from 'react';
import { getMirrorCandidates, MIRROR_PROBE_TIMEOUT_MS } from '../config/mirrors';
import { findAvailableMirrors } from '../utils/mirrorProbe';
import Loader from './ui/Loader';
import './MirrorList.scss';

export default function MirrorList() {
    const [state, setState] = useState('loading');
    const [mirrors, setMirrors] = useState([]);

    useEffect(() => {
        const controller = new AbortController();
        const candidates = getMirrorCandidates();

        if (candidates.length === 0) {
            setMirrors([]);
            setState('ready');
            return undefined;
        }

        const loadMirrors = async () => {
            try {
                const available = await findAvailableMirrors(candidates, {
                    signal: controller.signal,
                    timeoutMs: MIRROR_PROBE_TIMEOUT_MS,
                });

                if (controller.signal.aborted) {
                    return;
                }

                setMirrors(available);
                setState('ready');
            } catch {
                if (controller.signal.aborted) {
                    return;
                }

                setMirrors([]);
                setState('ready');
            }
        };

        loadMirrors();

        return () => {
            controller.abort();
        };
    }, []);

    return (
        <div className="mirror-list">
            <p className="mirror-list__label">Доступные зеркала</p>

            {state === 'loading' && (
                <Loader text="Проверяем зеркала..." />
            )}

            {state === 'ready' && mirrors.length > 0 && (
                <ul className="mirror-list__items">
                    {mirrors.map((mirror) => (
                        <li key={mirror.domain} className="mirror-list__item">
                            <a
                                className="mirror-list__link"
                                href={mirror.frontendUrl}
                            >
                                {mirror.domain}
                            </a>
                        </li>
                    ))}
                </ul>
            )}

            {state === 'ready' && mirrors.length === 0 && (
                <p className="mirror-list__empty">Сейчас нет доступных зеркал</p>
            )}
        </div>
    );
}
